import { execute, addQueryParams } from '@/api/utils'
import { GET, PUT, POST, DELETE } from '@/api/types'

export default {
  list (farmID, params = {}) {
    return execute(GET, addQueryParams(`farms/${farmID}/providers`, params))
  },
  create (farmID, payload) {
    return execute(POST, `farms/${farmID}/providers`, payload)
  },
  updateById (farmID, id, payload) {
    return execute(PUT, `farms/${farmID}/providers/${id}`, payload)
  },
  getById (farmID, id) {
    return execute(GET, `farms/${farmID}/providers/${id}`)
  },
  deleteById (farmID, id) {
    return execute(DELETE, `farms/${farmID}/providers/${id}`)
  }
}
